import { defineStore } from 'pinia';
import type { PriceStoreState } from '#/price';
const useFlightStore = defineStore('app-price', {
	// 持久化存储，可以根据自己需求配置哈
	state: (): PriceStoreState => ({
		adultPrice: 0,
		adultTax: 0,
		childPrice: 0,
		childTax: 0,
		infantPrice: 0,
		infantTax: 0,
		totalPrice: 0,
		otherInfo: [],
	}),
	actions: {
		setBasePrice(priceInfo: PriceStoreState): void {
			for (const i in priceInfo) {
				// @ts-ignore
				this[i] = priceInfo[i];
			}
		},
		setTotalPrice(totalPrice: number): void {
			this.totalPrice = totalPrice;
		},
	},
	getters: {
		getBasePrice(): PriceStoreState {
			return {
				adultPrice: this.adultPrice,
				adultTax: this.adultTax,
				childPrice: this.childPrice,
				childTax: this.childTax,
				infantPrice: this.infantPrice,
				infantTax: this.infantTax,
			};
		},
		getTotalPrice(): any {
			return this.totalPrice;
		}
	},
	//persist定义要做判断，因为localStorage是客户端参数，所以需要加process.client
	persist: process.client && {
		storage: sessionStorage,
		paths: ['curFlight']
	}
});

export const setBasePriceFun = (priceInfo: any) => {
	useFlightStore().setBasePrice(priceInfo);
};
export const getBasePriceFun = () => {
	return useFlightStore().getBasePrice;
};
export const setTotalPriceFun = (totalPrice: number) => {
	useFlightStore().setTotalPrice(totalPrice);
};
export const getTotalPriceFun = () => {
	return useFlightStore().getTotalPrice;
};
